import { enabledTaxes, hideCheckIcon, showCheckIcon } from "../components/price-vat";
import { waitForElement } from "./dom-utils";
import { cleanStr } from "./input-password";
import { createLoaderWithOverlay } from "./loader";
import { $Q } from "./query-selector";

export const getFormContaner = () => {
    return $Q('.sufio-vat-cart-form')
}

const updateLoggedIn = (formContainer) => {
    const emailInput = $Q('.sufio-vat-email-input', formContainer)
    const vatInput = $Q('.sufio-vat-number-input', formContainer)
    if (!emailInput || !vatInput) return

    if (getComputedStyle(emailInput).display === 'none') {
        vatInput.classList.add('is-only')
    }

    return
}

const hideIconCheck = (formContainer) => {
    const vatInput = $Q('.sufio-vat-number-input', formContainer)
    const buttonCancel = $Q('.sufio-vat-cancel-button', formContainer)
    const iconCheck = $Q('#sufio-check')
    if (!vatInput || !buttonCancel || !iconCheck) return

    if (getComputedStyle(vatInput).display !== 'none' || getComputedStyle(buttonCancel).display !== 'none') {
        iconCheck.style.display = 'none'
    } else {
        iconCheck.style.display = 'inline-block'
    }
}

const listenerForLinkClick = (sufioLink) => {
    const buttonCancel = $Q('.sufio-vat-cancel-button', sufioLink.parentNode.parentNode)
    if (!sufioLink || !buttonCancel) return
    sufioLink.addEventListener('click', (e) => {
        hideIconCheck(sufioLink.parentNode.parentNode)
    })
    buttonCancel.addEventListener('click', (e) => {
        hideIconCheck(buttonCancel.parentNode)
    })
}

const getSufioLink = () => {
    const formContainer = getFormContaner()
    return $Q('.sufio-vat-link', formContainer)
}

const addLinkToContainer = () => {
    const sufioLink = getSufioLink()
    const iconCheck = $Q('#sufio-check')
    if (!sufioLink || !iconCheck) return

    const container = document.createElement('div')
    container.classList.add('sufio-vat-link-container')
    sufioLink.parentNode.insertBefore(container, sufioLink)
    container.appendChild(sufioLink)
    container.insertAdjacentElement('afterbegin', iconCheck)
    iconCheck.style.display = 'inline-block'

    listenerForLinkClick(sufioLink)
}

export const changeTotalPrice = (formattedPrice) => {
    const el = $Q('#total-price-el .money')
    if (!el) return;

    const total = $Q('#btn_cart_total_price')

    const totalTaxesHide = $Q('#taxes-price-total')
    if (!total || !totalTaxesHide) return;

    const finalContent = formattedPrice ? totalTaxesHide.textContent : el.textContent;

    const originalTaxes = $Q('#btn_cart_total_taxes')
    const withoutTaxesText = $Q('#hc-text-element')
    const withTaxes = $Q('#ttc-text')

    if (originalTaxes && withoutTaxesText && withTaxes) {
        const finalTaxes = !formattedPrice
            ? withoutTaxesText.textContent
            : withTaxes.textContent

        originalTaxes.textContent = finalTaxes
    }

    total.textContent = finalContent
    return;
}

const hideTvaContainer = (hide = true) => {
    const el = $Q('.cartpage-footer__tva')
    if (el) el.style.display = hide ? 'none' : 'flex';
}

const getCustomerEmail = () => {
    const formContainer = getFormContaner()
    const fromInput = $Q('.sufio-vat-email-input > input', formContainer);
    if (fromInput) return fromInput.value;

    const fromLiquid = $Q('#customer_email_hide')
    if (fromLiquid) return fromLiquid.value;

    return null
}

const getVatValue = () => {
    const formContainer = getFormContaner()
    const fromInput = $Q('.sufio-vat-number-input > input', formContainer);
    if (fromInput) return fromInput.value;

    return null;
}

const setVatInputValue = (newValue) => {
    const formContainer = getFormContaner()
    const fromInput = $Q('.sufio-vat-number-input > input', formContainer);
    if (fromInput) fromInput.value = newValue;
}

const setUrlForSufio = (customerEmail, vatValue) => {
    const url = new URL('/apps/sufio/customer-vat', window.location.origin)
    url.searchParams.set('email', customerEmail)
    url.searchParams.set('vat_no', vatValue)
    url.searchParams.set('update', 'true')

    return url.toString()
}

const sendSufioForm = async () => {
    const customerEmail = getCustomerEmail()
    const vatValue = getVatValue()
    if (!customerEmail || !vatValue) return;

    const url = setUrlForSufio(customerEmail, vatValue)

    try {
        const res = await fetch(url, {
            method: "GET",
            credentials: 'include'
        });
        const cloned = res.clone()

        let data;
        try {
            data = await cloned.json();
        } catch {
            data = await cloned.text();
        }

        setVatInputValue(vatValue)
        return data
    } catch (error) {
        throw error;
    }
}

const changeStatusMessage = () => {
    const formContainer = getFormContaner()
    const spanMessage = $Q('.sufio-vat-number-status', formContainer);
    const sufioObj = SufioVAT || window.SufioVAT
    if (!spanMessage || !sufioObj) return

    spanMessage.textContent = cleanStr(sufioObj.labels.vatNumberInvalid)
    spanMessage.style.display = 'inline-flex'
}

const intersectButtonToSave = (formContainer) => {
    const checkButton = formContainer?.querySelector('.sufio-vat-cancel-button')
    const oldBtn = formContainer?.querySelector('.sufio-vat-save-button');
    if (!oldBtn || !checkButton) return;
    const newBtn = oldBtn.cloneNode(true);
    newBtn.setAttribute('type', 'button');
    oldBtn.replaceWith(newBtn);

    newBtn.addEventListener('click', async (e) => {
        e.preventDefault();

        const previousDisabled = newBtn.disabled;
        newBtn.disabled = true;
        newBtn.dataset.loading = 'true';
        
        const loader = createLoaderWithOverlay()
        newBtn.after(loader)
        newBtn.classList.add('hidden')
        checkButton.classList.add('hidden')


        try {
            const res = await sendSufioForm()
            
            if (res && res.result) {
                console.log("Valid result");
                hideTvaContainer(true)
                changeTotalPrice(false)
                enabledTaxes(false)
                showCheckIcon()
                checkButton.click()
            } else {
                changeStatusMessage()
                hideTvaContainer(false)
                changeTotalPrice(true)
                enabledTaxes(true)
                hideCheckIcon()
            }

        } catch (error) {
            changeStatusMessage()
            hideCheckIcon()
            console.error('[VAT] Error fetch:', error);
        } finally {
            newBtn.disabled = previousDisabled;
            delete newBtn.dataset.loading;
            loader.remove()
            newBtn.classList.remove('hidden')
            checkButton.classList.remove('hidden')
        }

    });

    newBtn.click()
    return;
}


export const sufioFormManipulator = () => {
    waitForElement('.sufio-vat-cart-form').then((formContainer) => {
        if (!formContainer) return

        updateLoggedIn(formContainer)
        addLinkToContainer()
        intersectButtonToSave(formContainer)

    }).catch(console.warn);
}